"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapMaker = exports.showButtonsFactory = exports.dropArrow = exports.areEqual = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _return_arrow = _interopRequireDefault(require("../../../asset/icons/return_arrow.svg"));

var _DeleteEdit = _interopRequireDefault(require("../../DeleteEdit/DeleteEdit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var areEqual = function areEqual(prevProps, nextProps) {
  return _lodash["default"].isEqual(prevProps.rowContent, nextProps.rowContent);
};

exports.areEqual = areEqual;

var dropArrow = function dropArrow(rowContent, value) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: _return_arrow["default"],
    className: "subMenu-button",
    alt: "return arrow"
  }), /*#__PURE__*/_react["default"].createElement("span", null, value && rowContent[value] ? rowContent[value] : '-'));
};

exports.dropArrow = dropArrow;

var showButtonsFactory = function showButtonsFactory(callback) {
  return function (rowContent) {
    var returnable = /*#__PURE__*/_react["default"].createElement(_DeleteEdit["default"], {
      edit: function edit() {
        return callback.editCooperator(rowContent);
      }
    });

    if (rowContent.can_delete === 'Y') {
      returnable = /*#__PURE__*/_react["default"].createElement(_DeleteEdit["default"], {
        edit: function edit() {
          return callback.editCooperator(rowContent);
        },
        "delete": function _delete() {
          return callback.deleteCooperator(rowContent);
        }
      });
    }

    return returnable;
  };
};

exports.showButtonsFactory = showButtonsFactory;

var mapMaker = function mapMaker(headers, keys) {
  var returnable = [];
  headers.forEach(function (element, index) {
    returnable.push([element, keys[index]]);
  });
  return new Map(returnable);
};

exports.mapMaker = mapMaker;